export default __webpack_public_path__ + "static/media/SWT1340.34I-35707_-20839_0.c50a823e.jpg";